import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

export const useNavigationLabels = () => {
  useLingui();

  return {
    home: t`Home`,
    members: t`Members`,
    profile: t`Profile`,
    store: t`Store`,
    switchClub: t`Switch Club`,
  };
};
